// extracted by mini-css-extract-plugin
module.exports = {"ContactWrapper":"contact_ContactWrapper__2zeJL","ContactList":"contact_ContactList__1KGLO","grow":"contact_grow__1dUUZ"};